<template>
<div>

<template v-if="loading">
    Loading...
</template>
<template v-else>
    <template v-if="list.length == 0">
    <div class="empty-list">
        This list is empty
    </div>
    </template>

    <template v-else>
    <table class="data-list" cellpadding="0" cellspacing="0">
        <thead>
            <tr>
                <th :class="{ center: column.type == 'boolean' }" v-for="(column, index) in definition" v-if="$noId(column.column_name)" v-html="column.label" :key="index" :align="column.align"></th>
                <th v-if="showRemove"></th>
            </tr>
        </thead>
        <tr class="list clickable-list-item" v-for="(item, index) in list" @click="itemClicked(item[definition[0].column_name])" :key="index">
            <td :class="{ center: column.type == 'boolean' }" v-for="(column, index) in definition" v-if="$noId(column.column_name)" :key="index" :align="column.align">
                <template v-if="!column.type">{{ item[column.column_name] }}</template>
                <template v-else-if="column.type == 'boolean'">
                    <i class="fas fa-check" :class="{ 'disabled': !item[column.column_name] }"></i>
                </template>
                <template v-else-if="column.type == 'image'">
                    <img :src="item[column.column_name]">
                </template>
            </td>
            <td class="links" v-if="showRemove"><i class="fas fa-times link pointer" @click.stop="itemRemove(item[definition[0].column_name])"></i></td>
        </tr>
        <tr v-if="totals" class="list">
            <td v-for="(column, index) in definition" v-if="$noId(column.column_name)" :key="index" :align="column.align">
                <b>{{ totals[column.column_name] }}</b>
            </td>
        </tr>
    </table>
    </template>
</template>

</div>
</template>

<script>
export default {
    name: 'list-component',
    props: {
        definition: {
            type: Array,
            required: true
        },
        list: {
            // type: Array,
            required: true
        },
        showRemove: {
            type: Boolean,
            required: false,
            default: false
        },
        totals: {
            type: Object,
            required: false
        },
        link: { // if list item is to be rendered as a router link
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            loading: false,
        }
    },
    methods: {
        itemClicked(itemId) {
            if (this.link == '') {
                this.$emit('clicked',itemId)
            } else {
                this.$router.push(this.link + itemId)
            }
        },
        itemRemove(itemId) {
            this.$emit('auditRemove', itemId)
        }
    }
}
</script>

<style lang="scss">
</style>
